module.exports = __webpack_public_path__ + "static/media/23-4.996fcac5.mp3";